import {toast} from "react-toastify";

export const numberToFinanceFormat = (number = 0, withSpaces = false) => {
    if (typeof number !== 'number') {
        return number;
    }
    if (!number) {
        return 0
    }
    let num = number
    if (!Number.isInteger(number)) {
        num = number.toFixed(1);
    }
    if (withSpaces) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const phoneNumberFormat = (number) => {
    number = number.indexOf('+') !== -1 ? number : `+${number}`;
    return number;
}

export const validPhone = phoneNumber =>{
    return phoneNumber && phoneNumber.length == 12;
}

export const requestErrorDisplay = (e, t, defaultTextKey = "common.toast.genericError") => {
    if (e?.__CANCEL__) return;
    e = e?.response?.data || e;
    const isTFunction = typeof t === "function";
    const defaultText = isTFunction 
        ? t(defaultTextKey) 
        : "Произошла ошибка, попробуйте позже";

    if (e?.errorText) {
        toast.error(e.errorText);
        return;
    }

    if (e?.errors) {
        for (const eKey in e.errors) {
            toast.error(e.errors[eKey][0]);
        }
        return;
    }

    if (e?.status === 409) {
        toast.error('В базе уже есть водитель с таким номером телефона');
    } else if (e?.message) {
        toast.error(e.message);
    } else {
        toast.error(defaultText);
    }
};


let timerDebounce = null
export const onDebounce = (fn, timer = 400) => {
    clearTimeout(timerDebounce)
    timerDebounce = setTimeout(fn, timer)
}

export const updateSet = (set, orderId, action) => {
  const newSet = new Set(set);
  if (action === "add") {
    newSet.add(orderId);
  } else if (action === "delete") {
    newSet.delete(orderId);
  }
  return newSet;
};

export const chatUpdateMap = (map, orderId, action, data = null) => {
  const newMap = new Map(map);
  if (action === "set") {
    newMap.set(orderId, data);
  } else if (action === "delete") {
    newMap.delete(orderId);
  }
  return newMap;
};
